<template>
  <component :is="currentComponent"></component>
</template>

<script>
import { mapState } from 'vuex'
export default {
  // 测试异步组件加载方式
  components: {
    'mecCommon': () => import('@/components/mecs/Common'),
    'mec000100': () => import('@/components/mecs/00-100')
  },
  beforeRouteLeave (to, from, next) {
    if (to.name === 'main') { from.query.sid = this.initializeSid }
    next()
  },
  mounted () {
    this.$store.dispatch('center/loadSysCenterDetail', this.$route.params.id)
  },
  data () {
    return {}
  },
  computed: {
    ...mapState({
      initializeSid: state => state.initializeSid
    }),
    currentComponent () {
      // 测试异步组件加载方式
      // return new Date().getMinutes() % 2 === 0 ? 'mec000100' : 'mecCommon'
      return 'mecCommon'
    }
  }
}

</script>
<style lang="scss" scoped>
@import "@/assets/style/variables.scss";

.header {
  height: 45px;
  background: #f7f6f9;
  box-shadow: 0 0 3px #999;
  z-index: 1;
  img {
    display: block;
    height: 100%;
    margin: 0 auto;
  }
}

.location-item {
}

.swiper-box {
  img {
    display: block;
    width: 375px;
    height: 160px;
  }
}

.quick-entry {
  overflow: hidden;
  //padding: 15px 5px 5px 15px;
  padding: 0;
  width: auto;
  margin: 5px;
  .col-6 {
    padding: 0;
    .box-child {
      border-radius: 8px;
      display: flex;
      padding: 30px 10px;
      color: #fff;
      margin: 5px;
      .text {
        padding-left: 10px;
        flex: 1;
      }
      h2 {
        font-weight: normal;
        font-size: 16px;
        margin-bottom: 5px;
      }
    }
  }
}

.quick-group {
  margin-bottom: 10px;

  .row {
    margin: 0 10px 10px;
    border-radius: 10px;
    background: $light;
    width: auto;
    padding: 15px 0;
    .col-4 {
      padding: 10px 0;
    }
  }
  .col-4 {
    text-align: center;
    img {
      width: 40px;
      height: 40px;
    }
  }
}
</style>
